<template>
<div class="chapter">
<div class="inner_page">
<a id="p4"></a>
<h1 class="chaptertitle chapter">Silencer to the Heart <br/>While Jogging Through a Park</h1>
<p class="follow">I shouldn’t have to go here</p>
<p class="left ">with you: a bandit ties the farmer’s dog to a century</p>
<div class="timebreak "> </div>
<p class="follow">oak by the untouched creek. You see human</p>
<p class="left ">interest piece, sunny &amp; rounding out the evening news</p>
<div class="timebreak "> </div>
<p class="follow">where I see eclipsed casket. Where I say released he will roam</p>
<p class="left ">the same radius. Surely, I don’t have to tell you there’s a gun</p>
<div class="timebreak "> </div>
<p class="follow">semi-automatic &amp; lodged in the black cherry thicket, but I do</p>
<p class="left ">have to tell you about the semi-automatic jail cell clanging</p>
<div class="timebreak "> </div>
<p class="follow">open, not for me, because that’s just sound world-making.</p>
<p class="left ">I’ll say it like this: I don’t jog in the park with my blindsides</p>
<div class="timebreak "> </div>
<p class="follow">shaded anymore. Look, here, through the spangled screen</p>
<p class="left ">door: there was once a kid, ordinary in every American leisure</p>
<div class="timebreak "> </div>
<p class="follow">except one. I won’t name him. You’ll look away.</p>
<p class="left ">Again: there was too much Shepherd’s Pie, a slice of Apple</p>
<div class="timebreak "> </div>
<p class="follow">&amp; one sturdy carving knife. In damp air hung glints</p>
<p class="left ">of siren moon, few sirens, sleepy porch lamps blinking on</p>
<div class="timebreak "> </div>
<p class="follow">&amp; an ache for antacids that jogged a man</p>
<p class="left ">to the corner store, like puttering wind, then back over</p>
<div class="timebreak "> </div>
<p class="follow">the town’s little blacktop hills near the park’s edge</p>
<p class="left ">where there was a shot streetlight &amp; lots of wheezing</p>
<div class="timebreak "> </div>
<p class="follow">over a bench, &amp; there were three shadows, a pit bull</p>
<p class="left ">tied to the bench &amp; a bulge in his gut</p>
<div class="timebreak "> </div>
<p class="follow">that was a bulge in his gut, which</p>
<p class="left ">must’ve looked to one shadow like a box cutter &amp; not</p>
<div class="timebreak "> </div>
<p class="follow">a roll of Tums, &amp; then there are, frankly,</p>
<p class="left ">too many black cherry thickets streaked with blood.</p>
<div class="timebreak "> </div>
<p class="follow">Sometimes, I can barely walk</p>
<p class="left ">out into daylight wearing a cotton sweatshirt</p>
<div class="timebreak "> </div>
<p class="follow">without trembling. &amp; surely I don’t have to</p>
<p class="left ">tell you who gets put down, which one walks away.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?479be4a9